
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Input, Form, Button, Icon } from 'antd'
import swal from 'sweetalert'

export default class SendWhatsappBox extends Component {

    constructor(props) {
        super(props)

        this.state = {
            clientName: '',
            clientTel: '',
            clientMessage: '',
            isValidTel: false,
            valid: false,
            url: '',
            ...props.data
        }

        this.onChange = this.onChange.bind(this)
        this.validate = this.validate.bind(this)
        this.send = this.send.bind(this)
    }

    cancel() {
        swal.close()
    }

    onChange(value, key) {
        if (!key) {
            key = value.target.name
            value = value.target.value
        }

        const newState = { [key]: value }

        telStatement: if (key === 'clientTel') {
            if (!value || typeof value !== 'string') {
                newState[key] = ''
                newState.isValidTel = false
                break telStatement
            }

            if ([4].indexOf(value.length) !== -1) {
                newState[key] = value.slice(0, 2)
                newState.isValidTel = false
                break telStatement
            }

            value = value.replace(/[\D\(\)\-]/g, '')

            if (!value) {
                value = ''
            }
            else if (value.length === 1) {
                value = `(${value}`
            }
            else if (value.length === 2) {
                value = `(${value}) `
            }
            else if (value.length <= 6) {
                const x = value.match(/(\d{2})(\d{1,4})/);
                value = `(${x[1]}) ${x[2]}`
            }
            else if (value.length <= 10) {
                const x = value.match(/(\d{2})(\d{4})(\d{1,4})/);
                value = `(${x[1]}) ${x[2]}-${x[3]}`
            }
            else {
                const x = value.match(/(\d{2})(\d{5})(\d{4})/);
                value = `(${x[1]}) ${x[2]}-${x[3]}`
            }

            newState[key] = value

            newState.isValidTel = /^\([1-9]{2}\) (?:[2-8]|9[1-9])[0-9]{2,3}\-[0-9]{4}$/.test(value)
        }

        this.setState(newState)
        this.validate({ ...this.state, ...newState })
    }

    validate(state) {
        let valid = state.isValidTel
        this.setState({ valid })
    }

    send() {
        if (!this.state.valid) {
            return
        }

        const tel = '55' + this.state.clientTel.toString().replace(/\D+/g, '')

        let message = ''
        // let message = `Olá, ${this.state.clientName}! Tudo bem?\n\n`
        if (this.state.clientMessage) {
            message += `${this.state.clientMessage}\n\n`
        }
        message += `${this.props.link}`

        const api = _isMobileOrTablet() ? 'api' : 'web'

        const url = `https://${api}.whatsapp.com/send?phone=${tel}&text=${encodeURIComponent(message)}`

        window.open(url)

        swal.close()

        function _isMobileOrTablet() {
            let check = false;
            (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
            return check;
        };
    }

    render() {
        const icon = 'fa fa-whatsapp'
        const text = 'Compartilhar galeria pelo Whatsapp'

        return (
            <div key='share-dialog'>
                <div className="dialog-header">
                    <div className="dialog-title" id="rcDialogTitle0">
                        {icon && <i className={icon} />} {text}
                    </div>
                    <button aria-label="Close" className="dialog-close" onClick={this.cancel}>
                        <Icon type='close' />
                    </button>
                </div>
                <div className='dialog-body'>
                    <Form layout="horizontal" onSubmit={this.props.onSubmit}>
                        {/* <FormItem label="Nome do cliente" key="clientName">
                            <Input
                                name="clientName"
                                value={this.state.clientName}
                                onChange={this.onChange}
                            />
                        </FormItem> */}

                        <FormItem label="Whatsapp" key="clientTel">
                            <Input
                                name="clientTel"
                                value={this.state.clientTel}
                                onChange={this.onChange}
                                placeholder="(31) 9 9999-9999"
                            />
                        </FormItem>

                        <FormItem label="Mensagem" key="clientMessage">
                            <Input.TextArea
                                name="clientMessage"
                                value={this.state.clientMessage}
                                onChange={this.onChange}
                                autosize={{ minRows: 4, maxRows: 6 }}
                            />
                        </FormItem>
                    </Form>
                </div>
                <div className="dialog-footer">
                    <div>
                        <Button className="sf-dialog-btn" onClick={this.cancel}>Cancelar</Button>
                        <Button className="sf-dialog-btn share-btn grey-salt" type="primary" onClick={this.send} disabled={!this.state.valid}>
                            {icon && <i className={icon} />}
                            Enviar
                        </Button>
                    </div>
                </div>
            </div >
        )
    }
}

const formItemLayout = {
    labelCol: {
        sm: { span: 24 },
        md: { span: 10 }
    },
    wrapperCol: {
        sm: { span: 24 },
        md: { span: 12 }
    },
    colon: false,
    className: 'ps-ant-formItem'
}

const FormItem = props => <Form.Item {...formItemLayout} {...props} />

SendWhatsappBox.propTypes = {
    data: PropTypes.object,
    onChange: PropTypes.func,
    onSubmit: PropTypes.func
}
